import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

document.addEventListener("DOMContentLoaded", () => {
    const el = document.querySelector('.js-gallery .swiper');
    if (!el) return;

    const current = el.closest('.c-gallery').querySelector('.js-gallery-current');
    const total = el.closest('.c-gallery').querySelector('.js-gallery-total');
    const currentSlides = el.querySelectorAll('.c-gallery__slide');

    const swiper = new Swiper(el, {
        modules: [Navigation, Pagination],
        speed: 1000,
        slidesPerView: "auto",
        spaceBetween: 24,
        loop: true,
        slidesOffsetBefore: 24,
        loopedSlides: Math.ceil(currentSlides.length / 2),
        slideToClickedSlide: false,
        simulateTouch: true,
        slidesPerView: 1,
        effect: 'slide',
        grabCursor: true,
        pagination: {
            el: '.js-gallery-pagination',
            type: 'progressbar',
        },
        navigation: {
            nextEl: '.js-gallery-next',
            prevEl: '.js-gallery-prev',
        },
        breakpoints: {
            768: {
                spaceBetween: 32,
                slidesOffsetBefore: 32,
                slidesPerView: 1.3
            },
            1290: {
                spaceBetween: 60,
                slidesOffsetBefore: 60,
                slidesPerView: 1.8
            }
        },
        on: {
            init: function () {
                if (current) current.textContent = String(this.realIndex + 1).padStart(2, '0');
                if (total) total.textContent = String(this.slides.length).padStart(2, '0');
            },
            slideChange: function (swiper) {
                if (current) current.textContent = String(this.realIndex + 1).padStart(2, '0');
                const slides = swiper.slides;

                slides.forEach(slide => {
                    const video = slide.querySelector('video');
                    if (!video) return;

                    if (
                        slide.classList.contains('swiper-slide-active') ||
                        slide.classList.contains('swiper-slide-prev') ||
                        slide.classList.contains('swiper-slide-next')
                    ) {
                        video.play().catch(() => {});
                    } else {
                        video.pause();
                        video.currentTime = 0;
                    }
                });
            }
        }
    });
});
